import { Routes } from '@angular/router';
import { RouterTools } from '@sol/components';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { AsmLicensingAuthority } from '@asm/components-core/models/asm-licensing-authority';

export const routesLicensing: Routes = [
  RouterTools.ofLazy(
    AsmRouteId.licensing_dashboard,
    () =>
      import('../components/licensing-dashboard-page/licensing-dashboard-page.component').then(
        m => m.LicensingDashboardPageComponent,
      ),
    [AsmLicensingAuthority.VIEW],
  ),
  RouterTools.ofLazy(
    AsmRouteId.licensing_customers,
    () =>
      import('../components/licensing-customers-page/licensing-customers-page.component').then(
        m => m.LicensingCustomersPageComponent,
      ),
    [AsmLicensingAuthority.VIEW],
  ),
  RouterTools.ofLazy(
    AsmRouteId.licensing_licenses,
    () =>
      import('../components/licensing-licenses-page/licensing-licenses-page.component').then(
        m => m.LicensingLicensesPageComponent,
      ),
    [AsmLicensingAuthority.VIEW],
  ),
  RouterTools.ofLazy(
    AsmRouteId.licensing_licenses_edit,
    () =>
      import('../components/licensing-edit-license-page/licensing-edit-license-page.component').then(
        m => m.LicensingEditLicensePageComponent,
      ),
    [AsmLicensingAuthority.VIEW],
  ),
  RouterTools.ofLazy(
    AsmRouteId.licensing_metrics,
    () =>
      import('../components/licensing-metrics-page/licensing-metrics-page.component').then(
        m => m.LicensingMetricsPageComponent,
      ),
    [AsmLicensingAuthority.VIEW],
  ),
  RouterTools.ofLazy(
    AsmRouteId.licensing_events,
    () =>
      import('../components/licensing-events-page/licensing-events-page.component').then(
        m => m.LicensingEventsPageComponent,
      ),
    [AsmLicensingAuthority.VIEW],
  ),
  RouterTools.ofLazy(
    AsmRouteId.licensing_units,
    () =>
      import('../components/licensing-units-page/licensing-units-page.component').then(
        m => m.LicensingUnitsPageComponent,
      ),
    [AsmLicensingAuthority.VIEW],
  ),
  RouterTools.ofLazy(
    AsmRouteId.licensing_actions,
    () =>
      import('../components/licensing-actions-page/licensing-actions-page.component').then(
        m => m.LicensingActionsPageComponent,
      ),
    [AsmLicensingAuthority.VIEW],
  ),
  RouterTools.ofLazy(
    AsmRouteId.licensing_documentation,
    () =>
      import('../components/licensing-documentation-page/licensing-documentation-page').then(
        m => m.LicensingDocumentationPageComponent,
      ),
    [AsmLicensingAuthority.VIEW],
  ),
];
